import React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '../../../../../../components';
import { BackButton } from '../../../../components';
import ModalConfirmation from '../../../../components/Modal/Modal';
import CancelConfirm from './components/CancelConfirm';
import Processing from '@/presentation/components/Processing';
import Spinner from '../../../../../../components/Spinner';
import Step from '../../UpdatePhoto/Register/components/Step';
import constants from '../../../../constants';
import requestInProgressImage from '../../../../../../../assets/illustrations/request_in_progress.svg';
import requestInProgressDskImage from '../../../../../../../assets/illustrations/procedures/cards/progress_dsk.svg';
import documentSuccessImage from '../../../../../../../assets/illustrations/procedures/cards/document-success.svg';
import documentSuccessDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-success-dsk.svg';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';

import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import ResumeDetail from '@/presentation/modules/procedures/components/Resume';
import CardProgress from '@/presentation/reusables/CardProgress';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import warningAlertIcon from '../../../../../../../assets/icons/warning-alert.svg';

const RetirementOfPeriodProgressView = (props: any) => {
  const {
    procedure,
    isLoading,
    isLoadingCancel,
    request,
    handleBack,
    handleCloseModalConfirmation,
    handleNullationModalConfirmation,
    showModalConfirmation
  } = props;

  const evalStatus = () =>
    constants.procedureStatus.removeFromPeriod.find(
      (s: any) => s.name === request?.status.status
    );

  return (
    <div data-testid="cmp-retirement_period_progress_view">
      <ContainerProcedure>
        <SubContainer style={{ marginBottom: 24 }}>
          <BackButton onClick={handleBack} />
        </SubContainer>
        {isLoading && <Spinner />}
        {request && !isLoading && (
          <SubContainer>
            <ToggleHeader
              name={procedure.name}
              amount={procedure.amount}
              duration={procedure.duration}
              date={procedure.endDate}
              status={request.status}
              childContent={
                <Block customized gap="16px">
                  <Block customized style={{ width: 'auto' }}>
                    El retiro del periodo lectivo es un trámite voluntario que
                    permite al alumno retirarse del ciclo académico actual.
                  </Block>
                  <Heading
                    text="Consideraciones"
                    level={3}
                    color="var(--text-text02)"
                    size={14}
                    lineHeight={20}
                    fontWeight="700"
                    className=""
                    align="flex-start"
                    width="100%"
                  />
                  <Block
                    customized
                    padding="4px 0px 0px 16px"
                    style={{ width: 'auto' }}
                  >
                    <ul style={{ listStyleType: 'disc' }}>
                      <li>
                        De aplicar la solicitud, solo se revertirán las cuotas
                        no vencidas, el pago de las cuotas vencidas no será
                        exonerado.
                      </li>
                      <li>
                        No recibirás calificaciones, ni repitencia en las
                        asignaturas matriculadas.
                      </li>
                      <li>No debes tener sanción disciplinaria.</li>
                      <li>La confirmación será enviada a tu correo UTP.</li>
                    </ul>
                  </Block>
                </Block>
              }
            />
            <TextTitle title="Progreso" />
            <Block
              customized
              padding={isMobile ? '20px 0px 0px 8px' : '20px 0px 0px 16px'}
            >
              <Step name="Registro de Solicitud" order={1} isComplete>
                <ResumeDetail
                  title="Detalle de solicitud:"
                  data={procedure?.detail?.removeFromPeriodDetail}
                  labels={['Motivo', 'Contacto', 'Horario de contacto']}
                  fields={['reason', 'contact', 'bussinessHour']}
                  showBullets
                />
              </Step>
              <Step
                name={procedure.steps[1].name}
                order={procedure.steps[1].order}
                // date={procedure.steps[1].date}
                isComplete={procedure.steps[1].isComplete}
                isCurrent={procedure.steps[1].isCurrent}
                isLast
              >
                <ResumeDetail
                  data={procedure?.detail?.removeFromPeriodDetail}
                  labels={[
                    'Fecha de solicitud',
                    request.status.status === 'PENDIENTE'
                      ? 'Fecha estimada de respuesta'
                      : 'Fecha de respuesta'
                  ]}
                  fields={[
                    'requestDate',
                    request.status.status === 'PENDIENTE'
                      ? 'probableDateOfAttention'
                      : 'responseDate'
                  ]}
                />
                {!evalStatus()?.isComplete ? (
                  <CardProgress
                    image={[requestInProgressImage, requestInProgressDskImage]}
                    title={`Tu solicitud está en proceso`}
                    subtitle={
                      'Un asesor se pondrá en contacto contigo para atender tu solicitud.'
                    }
                  >
                    <Block
                      customized
                      backgroundColor="#d5e5f0"
                      borderRadius="8px"
                      gap="8px"
                      flexDirection="row"
                      padding="16px"
                      margin="16px 0px 0px 0px"
                    >
                      <div
                        style={{
                          minWidth: '24px',
                          minHeight: '24px',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                      >
                        <img
                          src={warningAlertIcon}
                          alt="warningAlertIcon"
                          style={{
                            width: '20px',
                            height: '20px',
                            maxWidth: 'none'
                          }}
                        />
                      </div>
                      <Text
                        fontWeight="400"
                        fontSize="14px"
                        lineHeight="20px"
                        color="#161D1F"
                      >
                        Recuerda estar alerta al número registrado.
                      </Text>
                    </Block>
                  </CardProgress>
                ) : (
                  <></>
                )}
                {evalStatus()?.isComplete && evalStatus()?.isApproved && (
                  <CardProgress
                    image={[documentSuccessImage, documentSuccessDskImage]}
                    title={`Tu solicitud ha sido aprobada`}
                    subtitle={
                      'Ya te encuentras retirado del periodo actual. Revisa tu correo UTP para más información.'
                    }
                  />
                )}
                {evalStatus()?.isComplete && !evalStatus()?.isApproved && (
                  <CardProgress
                    image={[documentFailedImage, documentFailedDskImage]}
                    title={`Tu solicitud no procede`}
                    subtitle={'Revisa tu correo UTP para más información.'}
                  />
                )}
              </Step>
            </Block>
          </SubContainer>
        )}

        <Processing isOpen={isLoadingCancel} />
        <ModalConfirmation
          show={showModalConfirmation}
          handleClose={handleCloseModalConfirmation}
        >
          <CancelConfirm
            handleClickConfirm={handleNullationModalConfirmation}
            handleClickCancel={handleCloseModalConfirmation}
          />
        </ModalConfirmation>
      </ContainerProcedure>
    </div>
  );
};

export default RetirementOfPeriodProgressView;
